module.exports = __webpack_public_path__ + "static/media/32x152.0e2f87c1.png";